(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog"] && !Shopify.designMode) return;
  try {
    
  class TomCatalog extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-cat-grid]');
      if (!this.grid) return;
      this.cards = Array.from(this.grid.querySelectorAll('.tom-cat-card'));
      this.buttons = Array.from(this.querySelectorAll('[data-cat]'));
      this.select = this.querySelector('[data-cat-sort]');
      this.cat = 'all';

      this.buttons.forEach((b) =>
        b.addEventListener('click', () => this.setCat(b.dataset.cat))
      );
      if (this.select) {
        this.select.addEventListener('change', () => this.apply());
      }
      this.apply();
    }

    setCat(cat) {
      this.cat = cat;
      this.buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.cat === cat));
      this.apply();
    }

    apply() {
      this.cards.forEach((c) => {
        const show = this.cat === 'all' || c.dataset.cat === this.cat;
        c.style.display = show ? '' : 'none';
      });
      this.sort(this.select ? this.select.value : 'featured');
    }

    sort(mode) {
      const visible = this.cards.filter((c) => c.style.display !== 'none');
      let ordered = visible;
      if (mode === 'price-asc') {
        ordered = [...visible].sort((a, b) => parseFloat(a.dataset.price || 0) - parseFloat(b.dataset.price || 0));
      } else if (mode === 'price-desc') {
        ordered = [...visible].sort((a, b) => parseFloat(b.dataset.price || 0) - parseFloat(a.dataset.price || 0));
      } else if (mode === 'name') {
        ordered = [...visible].sort((a, b) => (a.dataset.name || '').localeCompare(b.dataset.name || ''));
      }
      ordered.forEach((c) => this.grid.appendChild(c));
    }
  }

  if (!customElements.get('tom-catalog')) {
    customElements.define('tom-catalog', TomCatalog);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  class TomContact extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.chips = Array.from(this.querySelectorAll('[data-topic-label]'));
      this.topicInput = this.querySelector('[data-topic-input]');
      this.formError = this.querySelector('[data-form-error]');

      this.chips.forEach((chip) =>
        chip.addEventListener('click', () => this.selectTopic(chip))
      );
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.validate(e));
      }
    }

    selectTopic(chip) {
      this.chips.forEach((c) => c.classList.toggle('is-active', c === chip));
      if (this.topicInput) this.topicInput.value = chip.dataset.topicLabel;
    }

    validate(e) {
      if (!this.form) return;
      const checks = [
        ['contact[name]', (v) => v.trim().length > 0],
        ['contact[email]', (v) => /.+@.+\..+/.test(v.trim())],
        ['contact[body]', (v) => v.trim().length > 0],
      ];
      let ok = true;
      checks.forEach(([name, test]) => {
        const el = this.form.querySelector('[name="' + name + '"]');
        if (!el) return;
        const valid = test(el.value);
        el.classList.toggle('has-error', !valid);
        if (!valid) ok = false;
      });
      if (!ok) {
        e.preventDefault();
        if (this.formError) this.formError.classList.add('is-visible');
      }
    }
  }

  if (!customElements.get('tom-contact')) {
    customElements.define('tom-contact', TomContact);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-blanks"] && !Shopify.designMode) return;
  try {
    
  class TomProductSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.tom-slide'));
      if (this.slides.length <= 1) return;

      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 4000;
      this.dots = Array.from(this.querySelectorAll('[data-tom-dot]'));
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      const prev = this.querySelector('[data-tom-prev]');
      const next = this.querySelector('[data-tom-next]');
      if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); this.go(this.index - 1); });
      if (next) next.addEventListener('click', (e) => { e.preventDefault(); this.go(this.index + 1); });
      this.dots.forEach((dot, i) => dot.addEventListener('click', (e) => { e.preventDefault(); this.go(i); }));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.show(0);
      this.start();
    }

    disconnectedCallback() { this.stop(); }

    show(i) {
      this.slides.forEach((slide, idx) => {
        const active = idx === i;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === i));
      this.index = i;
    }

    go(i) {
      const n = this.slides.length;
      this.show(((i % n) + n) % n);
      this.start();
    }

    start() {
      this.stop();
      if (this.reduce.matches || this.slides.length <= 1) return;
      this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), this.interval);
    }

    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }
  }

  if (!customElements.get('tom-product-slider')) {
    customElements.define('tom-product-slider', TomProductSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
